export default __webpack_public_path__ + "static/2015-ultrafest-at-a01b31f8f32fcf58a3893970409ced43.pdf";